module.exports = __webpack_public_path__ + "media/images/pc/specials/common/recommend_chapel_8-7c1a37b36dfd4085555e496c90680e30.jpg";